export default "__VITE_ASSET__DMft6l1u__"